// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dfi_J","clinicsSelect":"styles_clinicsSelect__1yPyd"};